"use client";
import { useEffect, useRef, useContext } from "react";
import { AppContext } from "@/src/context/AppContext";

export default function CouponCashier({ openCashier, Click_Login }) {
  const ranOnce = useRef(false);
  const { user } = useContext(AppContext);

  useEffect(() => {
    if (ranOnce.current) return;
    if (typeof window === "undefined") return;

    const url = new URL(window.location.href);
    const coupon = url.searchParams.get("coupon");
    if (!coupon) return;

    if (user) {
      ranOnce.current = true;
      openCashier("22", coupon);
      url.searchParams.delete("coupon");
      window.history.replaceState({}, "", url.pathname + url.search);
    } else {
      Click_Login();
    }
  }, [user, openCashier, Click_Login]);

  return null;
}
